import DCFPagination from '@dcf/js/components/dcf-pagination.js';

export default class UNLPagination extends DCFPagination {
    constructor(paginationNav, options = {}) {
        super(paginationNav, options);
    }
}
